// Famous NZ earthquakes for the journal's time-travel picker.
// Each entry defines a 7-day window centred (roughly) on the quake day so
// the journal shows the days leading up to and following the event.

export const FAMOUS_QUAKES = [
  {
    id: "kaikoura-2016",
    name: "Kaikoura",
    date: "2016-11-14",
    magnitude: 7.8,
    subtitle: "M 7.8 · midnight rupture · 2016",
  },
  {
    id: "east-cape-2021",
    name: "East Cape",
    date: "2021-03-05",
    magnitude: 7.3,
    subtitle: "M 7.3 · tsunami warning · 2021",
  },
  {
    id: "darfield-2010",
    name: "Darfield",
    date: "2010-09-04",
    magnitude: 7.1,
    subtitle: "M 7.1 · Canterbury dawn · 2010",
  },
  {
    id: "seddon-2013",
    name: "Seddon",
    date: "2013-08-16",
    magnitude: 6.6,
    subtitle: "M 6.6 · Cook Strait shakes · 2013",
  },
  {
    id: "christchurch-2011",
    name: "Christchurch",
    date: "2011-02-22",
    magnitude: 6.3,
    subtitle: "M 6.3 · lunchtime February · 2011",
  },
];

// Given a quake date (YYYY-MM-DD in NZ time), return a 7-day window
// with the quake day roughly in the middle (Day 4 of 7).
export const weekAround = (isoDate) => {
  const d = new Date(`${isoDate}T12:00:00`);
  const start = new Date(d);
  start.setDate(start.getDate() - 3);
  start.setHours(0, 0, 0, 0);
  const end = new Date(d);
  end.setDate(end.getDate() + 3);
  end.setHours(23, 59, 59, 999);
  return { start, end };
};

export const shiftWeek = (start, end, direction) => {
  const s = new Date(start);
  const e = new Date(end);
  s.setDate(s.getDate() + 7 * direction);
  e.setDate(e.getDate() + 7 * direction);
  return { start: s, end: e };
};

export const isThisWeek = (start, end) => {
  const now = new Date();
  return end.getTime() >= now.getTime() - 12 * 3600 * 1000;
};

export const fmtWeekLabel = (start, end) => {
  const opts = { month: "short", day: "numeric" };
  const s = start.toLocaleDateString(undefined, opts);
  const e = end.toLocaleDateString(undefined, opts);
  const yr = end.getFullYear();
  return `${s} – ${e}, ${yr}`;
};
